module.exports = "/lucky-balls/img/weager/Lower_Raise/Button_Lower_pressed.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Button_Lower_pressed.png
// module id = 1166
// module chunks = 0